import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

class ForgotPassword extends Component {

	componentWillMount() {
		if(this.props.user.inValidLoginAttempts < 5) {
			browserHistory.push("/login");
		}
	}

    render() {
		const applicationUrl = window.location.host;
        return (
			<div>
				<h2>Login Failed</h2>
				<p>You have exceeded maximum attempts to login. If you have forgotten your password please reset using below link.</p>
				<p><a href={"https://b2b.geappliances.com/pwm/public/forgottenpassword?forwardURL=http://"+applicationUrl}>Forgot Password</a></p>
			</div>
        );
    }

}

const mapStateToProps = (state) => {
	return { user: state.user };
};

ForgotPassword = connect(mapStateToProps)(ForgotPassword);
export default ForgotPassword;



// WEBPACK FOOTER //
// ./src/App/components/PreLogin/ForgotPassword/index.js